import { useSelector } from 'react-redux';

import { SubscriberResponseDto } from 'theSource/types';
import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import { GET_PROFILE_QUERY_KEY } from './utils';
import { useConfigurationQuery } from 'theSource/queries';

export interface UseEnrollmentProfileQueryOutput {
  subscriber?: SubscriberResponseDto;
  isLoadingSubscriber: Boolean;
  isFetchingSubscriber: Boolean;
}

export interface UseEnrollmentProfileQueryProps {
  lumosEnabled: boolean;
}

export const useEnrollmentProfileQuery = ({
  lumosEnabled,
}: UseEnrollmentProfileQueryProps): UseEnrollmentProfileQueryOutput => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const {
    data: subscriber,
    isLoading: isLoadingSubscriber,
    isFetching: isFetchingSubscriber,
  } = useApiQuery<SubscriberResponseDto>({
    queryKey: GET_PROFILE_QUERY_KEY,
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    endpoint: '/employees/profile',
    enabled: lumosEnabled && Boolean(isAuthenticated),
  });

  return { subscriber, isLoadingSubscriber, isFetchingSubscriber };
};
